import {
  // TherapistListResponseSchema,
  type TherapistListRequest,
} from '@hedepy/common/schemas/routes/api/v2/therapist'

import { useApis } from '@/legacy-src/contexts/api-context'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { useSwrQuery, type SwrQueryOptions } from '@/src/domains/swr/hooks/useSwrQuery'

export const useGetTherapistsList = <Config extends SwrQueryOptions<TherapistType[] | undefined> | undefined>(
  params?: TherapistListRequest,
  options?: Config,
) => {
  const { api } = useApis()

  return useSwrQuery(
    [JSON.stringify(params), 'list', 'therapists', 'POST'],
    async () => {
      if (params === undefined) {
        return undefined
      }

      const { data } = await api.postTherapistList(params)

      // There is a lie until we have the true schema
      // return TherapistListResponseSchema.parse(data);
      return data as unknown as TherapistType[]
    },
    options,
  )
}
